import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ToasterState } from '../types/toast.types'

const MAX_VISIBLE_TOASTS = 5

const initialState: ToasterState = {
  toasters: [],
}

const toasterSlice = createSlice({
  name: 'toaster',
  initialState,
  reducers: {
    addToaster: (
      state: ToasterState,
      action: PayloadAction<{
        id: string
        type: 'error' | 'success' | 'warning' | 'info'
        message: string
      }>
    ) => {
      state.toasters.push(action.payload)
      if (state.toasters.length > MAX_VISIBLE_TOASTS) {
        state.toasters = state.toasters.slice(-MAX_VISIBLE_TOASTS)
      }
    },
    removeToaster: (state: ToasterState, action: PayloadAction<string>) => {
      state.toasters = state?.toasters?.filter(
        (toast) => toast?.id !== action?.payload
      )
    },
    clearToast: (state: ToasterState) => {
      state.toasters = []
    },
  },
})

export const { addToaster, removeToaster, clearToast } = toasterSlice.actions
export default toasterSlice.reducer
